import React from 'react';
import { OverlappingValueProps } from '../ValueProps';
import cnames from 'classnames';

import './Jumbotron.less';
import { Experiment } from '../Experiment';

const CNAME = 'Jumbotron';

const Jumbotron = ({ children }) => (
  <div className={CNAME}>
    <Experiment name="HA_PTA_HP_StayzOnPlatform">
      {stayzOnPlatform => (
        <Experiment name="HA_PTA_HP_VrboRefreshMessaging">
          {vrboRefreshMessageValue => (
            <div className={cnames(`${CNAME}__wrapper`, {
              [`${CNAME}__wrapper--overlapping-value-props`]: stayzOnPlatform === 0,
              [`${CNAME}__wrapper--vrbo-refresh-message`]: vrboRefreshMessageValue === 1
            })}
            >
              <div className={`${CNAME}__content`}>
                {children}
              </div>
              { stayzOnPlatform === 0 && <OverlappingValueProps /> }
            </div>
          )
          }
        </Experiment>
      )
      }
    </Experiment>
  </div>
);

export default Jumbotron;